<footer>
  <div class="container py-3 py-lg-4">
    <div class="row">
      <div class="col-12 text-center mb-3">
        <small>
          Material exclusivo para clientes de BAT con fines de capacitación y
          comunicación.
        </small>
      </div>

      <div class="col-12 text-center">
        <p class="mb-0">
          FUMAR ES CAUSA DE CÁNCER. PROHIBIDA SU VENTA A MENORES.
        </p>
      </div>
    </div>
  </div>
</footer>
